import StatementsModal from './StatementsModal';

export default StatementsModal;
